import { render, staticRenderFns } from "./LogConversationModal.vue?vue&type=template&id=3b671999"
import script from "./LogConversationModal.vue?vue&type=script&lang=js"
export * from "./LogConversationModal.vue?vue&type=script&lang=js"
import style0 from "./LogConversationModal.vue?vue&type=style&index=0&id=3b671999&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports